// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dont-break-out[data-v-3507cfc4]{word-wrap:break-word;-webkit-hyphens:auto;hyphens:auto;-ms-word-break:break-all;word-break:break-all;word-break:break-word}.dont-break-out p[data-v-3507cfc4]{margin-bottom:3px!important}[data-v-3507cfc4] .text-body{color:var(--v-text-base)}.text-title[data-v-3507cfc4]{color:var(--v-title-base)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
